export const GenerateRandomCode = {
  async create(
    {
      foreign_table,
      foreign_value,
      table,
      onField,
      indexField,
      amount,
      pattern,
      onOption,
      prefix,
      autoIncrement,
      pattern2,
    },
    proxy,
    _token,
    criteria
  ) {
    const res = await fetch(`${proxy}/apis/generate/randomcode`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `${_token}`,
        Criteria: criteria,
      },
      body: JSON.stringify({
        foreign_table,
        foreign_value,
        table,
        onField,
        indexField,
        amount,
        pattern,
        onOption,
        prefix,
        autoIncrement,
        pattern2,
      }),
    });
    return res.json();
  },
};
